import React, { useEffect, useState } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Edit,
  Inject,
  CommandColumn,
} from "@syncfusion/ej2-react-grids";
import axios from "axios";
import { contextMenuItems, postsGrid } from "../data/dummy";
import { Header } from "../components";
import { baseUrl } from "../data/baseURL";
import { format } from "date-fns-jalali";
import { Navigate } from "react-router-dom";

const Post = () => {
  const [ordersData, setOrdersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [navigate, setNavigate] = useState("");
  const editing = { allowDeleting: true };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${baseUrl}/Article/Article/GetArticlesAdmin`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        let data = []
        if(response) {
          response.data.data.forEach(post => {
            data.push({
              ...post,
              comments: post.comments.length,
              publishDate: format(new Date(post.publishDate * 1000), "d MMMM yyyy")
            })
          })
        }
        setOrdersData(data);
      } catch (error) {
        console.error("Error fetching data from API", error);
      }
    };
    fetchData();
  }, []);


  const handleDelete = async (data) => {
    setLoading(true);
    const { id } = data;
    const token = localStorage.getItem("token");

    try {
      await axios.delete(`${baseUrl}/Article`, {
        params: { id },
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrdersData(ordersData.filter((item) => item.Id !== id));
      setLoading(false);
      window.alert("عکس با موفقیت حذف شد");
    } catch (error) {
      console.error("Error deleting post:", error);
      setLoading(false);
    }
  };

  const handleActionBegin = (args) => {
    if (args.requestType === "delete") {
      handleDelete(args.data[0]);
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Page" title="لیست عکس ها" />
      <GridComponent
        id="gridcomp"
        dataSource={ordersData}
        allowPaging
        allowSorting
        allowExcelExport
        allowPdfExport
        contextMenuItems={contextMenuItems}
        toolbar={["Delete"]}
        actionBegin={handleActionBegin}
        editSettings={editing}
        rowSelected={(args) => {if(args.target?.className == "e-btn-icon e-icons e-delete" || args.target?.className == undefined) return null; setNavigate(<Navigate to="/editor" state={args.data} />)}}
      >
        <ColumnsDirective>
          {postsGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        <Inject
          services={[
            Resize,
            Sort,
            ContextMenu,
            Filter,
            Page,
            ExcelExport,
            PdfExport,
            CommandColumn,
            Edit
          ]}
        />
        {navigate}
      </GridComponent>
    </div>
  );
};

export default Post;
